import { Icon } from '@pwc/pwc-deals-ui';
import { isEmpty as _isEmpty, first as _first, map as _map } from 'lodash';
import PropTypes from 'prop-types';
import React, { useState, useCallback, useRef, useEffect } from 'react';
import './ProjectFilter.scss';
import { projectStates } from './ProjectFilterConsts';

const FilterItem = ({ id, name, onClick, iconType, showIcon }) => {
  const handleOnClick = useCallback(() => {
    if (onClick) {
      onClick(id);
    }
  }, [id, onClick]);

  return (
    /* eslint-disable-next-line */
    <div
      className="project-filter__item"
      data-testid="project-filter-item"
      // eslint-disable-next-line
      onClick={handleOnClick}
    >
      {name}
      {showIcon && (
        <Icon
          name={iconType}
          className="fill icon-orange"
          width={15}
          data-testid={`project-filter-item-icon-${iconType}`}
        />
      )}
    </div>
  );
};

const ProjectFilter = ({ items, selectedItemId, selectItem }) => {
  const [isOpened, setIsOpened] = useState(false);
  let selectedItem = items.find((item) => item.id === selectedItemId);
  if (!selectedItem && !_isEmpty(items)) {
    selectedItem = _first(items);
  }
  const remainingItems = items.filter((item) => item.id !== selectedItemId);
  const dropdownRef = useRef(null);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpened(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  });

  const handleOnMenuOpen = useCallback(() => {
    setIsOpened(!isOpened);
  }, [isOpened]);

  const handleOnSelectItem = useCallback(
    (id) => {
      setIsOpened(false);
      if (selectItem) {
        selectItem(id);
      }
    },
    [selectItem]
  );

  return (
    <div
      className={`project-filter ${
        isOpened
          ? 'project-filter-active-state'
          : 'project-filter-inactive-state'
      }`}
      data-testid="project-filter"
      ref={dropdownRef}
    >
      <FilterItem
        id={selectedItem.id}
        name={selectedItem.name}
        onClick={handleOnMenuOpen}
        iconType={isOpened ? 'up-chevron' : 'down-chevron'}
        showIcon
      />
      {isOpened && (
        <div className="project-filter__list">
          {_map(remainingItems, (item) => (
            <FilterItem
              id={item.id}
              key={item.id}
              name={item.name}
              onClick={handleOnSelectItem}
            />
          ))}
        </div>
      )}
    </div>
  );
};

ProjectFilter.defaultProps = {
  selectedItemId: projectStates['po.navtopbar.selectall'],
  items: [],
};

ProjectFilter.propTypes = {
  selectedItemId: PropTypes.number,
  selectItem: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.exact({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    })
  ),
};

export default ProjectFilter;
